export default __webpack_public_path__ + "static/media/JobCard2.c6b425fa.jpeg";